<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyQuestionTabLinks />
                    <SurveyQuestionUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/surveys/${$route.params.id}/questions`)"
                        @deleted="$router.push(`/surveys/${$route.params.id}/questions`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyQuestionTabLinks from '@/components/surveys/SurveyQuestionTabLinks';
    import SurveyQuestionUpsertForm from '@/components/surveys/SurveyQuestionUpsertForm';

    export default {
        name: 'SurveyEdit',

        components: {
            SurveyQuestionTabLinks,
            SurveyQuestionUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id, question_id } = this.$route.params;
                this.entity = (await this.axios.get(`/surveys/${id}/questions/${question_id}`)).data;
            },
        },
    };
</script>
